import React from 'react';
import { Avatar, Chip } from '@mui/material';

export const FONT = 'Mulish, sans-serif';

export const authToken = () => {
  const raw = sessionStorage.getItem('token');
  return raw ? `Bearer ${raw}` : '';
};

export const BUSINESS_TYPES = [
  { value: 'individual', label: 'Individual' },
  { value: 'proprietor', label: 'Proprietor' },
  { value: 'company', label: 'Company' },
  { value: 'distributor', label: 'Distributor' },
];
export const PAY_MODES = ['Bank Transfer', 'UPI', 'Cheque', 'Cash'];

export const GST_RX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const PAN_RX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const IFSC_RX = /^[A-Za-z]{4}0[A-Z0-9]{6}$/;

export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const typeLabel = (v) => BUSINESS_TYPES.find((b) => b.value === v)?.label || (v ? v : '—');
export const maskAccount = (n) => (n ? `•••• ${String(n).slice(-4)}` : '');

export const StatusChip = ({ status }) => {
  const on = status === 'active';
  return <Chip size="small" label={on ? 'Active' : 'Inactive'} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: on ? '#dcfce7' : '#f1f5f9', color: on ? '#166534' : '#475569' }} />;
};

export const SupplierAvatar = ({ supplier, size = 38 }) => (
  <Avatar sx={{ width: size, height: size, bgcolor: '#e0e7ff', color: '#3730a3', fontWeight: 800, fontSize: size * 0.4 }}>
    {(String(supplier?.name || 'S').trim()[0] || 'S').toUpperCase()}
  </Avatar>
);
